export enum UrlEnum {
  AbstractFactoryPattern = "implementation-of-the-abstract-factory-pattern",
  BuilderPattern = "implementation-of-the-builder-pattern",
  VisitorPattern = "implementation-of-the-visitor-pattern",
}
